export default {
    'warning.capsLock'            : 'La touche VERR.MAJ est activé.',
}